import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { manageUserAction, type ManageUserActionPayload } from '@/features/users/api'

export function useManageUserMutation(options?: UseMutationOptions<any, unknown, ManageUserActionPayload>) {
  return useMutation({
    mutationFn: manageUserAction,
    ...options
  })
}
